export enum MediaType {
  COMMERCIAL_REGISTRATION = 'COMMERCIAL_REGISTRATION',
  DOCUMENT = 'DOCUMENT',
  IMAGE = 'IMAGE',
  LICENSE = 'LICENSE'
}
